import { render, staticRenderFns } from "./PagePreviewBig.vue?vue&type=template&id=7f92f463&scoped=true"
import script from "./PagePreviewBig.vue?vue&type=script&lang=js"
export * from "./PagePreviewBig.vue?vue&type=script&lang=js"
import style0 from "./PagePreviewBig.vue?vue&type=style&index=0&id=7f92f463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f92f463",
  null
  
)

export default component.exports